import api from '@/services/utils/base';

export default class Currency {
  getList(params: any) {
    return api.get('currencies', params).then((res: any) => {
      return Promise.resolve(res.data.payload);
    })
    .catch((err: any) => {
      return Promise.reject(err);
    });
  }

  getExchangeRates({ base_currency = null } = {}) {
    const params = base_currency ? `?base_currency=${base_currency}` : ''

    return api.get(`/currencies/exchange-rates${params}`)
      .then((res: any) => Promise.resolve(res.data.payload))
      .catch((err: any) => Promise.reject(err))
  }
}
